module.exports = "/assets/data/dda56a722d3904453863a7b37a978d08-DN36.data.json";